import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "./AuthPage.css";
import { Link } from "react-router-dom";
import payweekwhite from "./ginoc_logo_transparent.png";

const AuthPage = () => {
    const [loginData, setLoginData] = useState({ email: "", password: "" });
    const [registerData, setRegisterData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
    });
    const [isSmsConsentChecked, setIsSmsConsentChecked] = useState(false);
    //const [isLoginView, setIsLoginView] = useState(false); 
    const navigate = useNavigate();

    const handleLoginChange = (e) => {
        const { name, value } = e.target;
        setLoginData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await api.post("/login", loginData);

            if (data.accessToken) {
                api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
                alert("Logged in successfully!");
                navigate("/dashboard/business/user/profile");
            } else {
                alert(data.message);
                navigate("/otp", { state: { userId: data.userId } });
            }
        } catch (err) {
            alert("Login failed.");
        }
    };

    const handleRegisterChange = (e) => {
        const { name, value } = e.target;
        setRegisterData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSmsConsentChange = (e) => {
        setIsSmsConsentChecked(e.target.checked);
    };

    const handleRegisterSubmit = async (e) => {
        e.preventDefault();
        if (registerData.password !== registerData.confirmPassword) {
            alert("Passwords do not match!");
            return;
        }
        if (!isSmsConsentChecked) {
            alert("You must agree to receive SMS messages for verification purposes.");
            return;
        }
        try {
            await api.post("/register", registerData);
            alert("Registration successful!");

            setRegisterData({
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                password: "",
                confirmPassword: "",
            });
            setIsSmsConsentChecked(false);

            // Switch to the login view after registration
            // setIsLoginView(true);
            // document.getElementById("chk").checked = true;
        } catch (error) {
            console.error("Registration error:", error.response?.data || error.message);
            alert(error.response?.data?.message || "Registration failed.");
        }
    };

    // const handleToggleView = () => {
    //     setIsLoginView((prev) => !prev); // Toggle between signup and login
    // };

    return (
        <>
            <body className="background">
                <div className="logowhite">
                  <img src={payweekwhite} alt="whitelogo" />
                </div>
                <div className="main">
                    {/* <input 
                        type="checkbox" 
                        id="chk" 
                        aria-hidden="true" 
                        onChange={handleToggleView} 
                        checked={isLoginView}
                    /> */}

                    {/* Register Form */}
                    <div className="signup">
                        <form onSubmit={handleRegisterSubmit}>
                            <label htmlFor="chk">
                                Sign up
                            </label>
                            <div className="nameinput">
                                <input
                                    type="text"
                                    name="first_name"
                                    placeholder="First Name"
                                    value={registerData.first_name}
                                    onChange={handleRegisterChange}
                                    required
                                />
                                <input
                                    type="text"
                                    name="last_name"
                                    placeholder="Last Name"
                                    value={registerData.last_name}
                                    onChange={handleRegisterChange}
                                    required
                                />
                            </div>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={registerData.email}
                                onChange={handleRegisterChange}
                                required
                            />
                            <input
                                type="text"
                                name="phone"
                                placeholder="Phone"
                                value={registerData.phone}
                                onChange={handleRegisterChange}
                                required
                            />
                            <input
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={registerData.password}
                                onChange={handleRegisterChange}
                                required
                            />
                            <input
                                type="password"
                                name="confirmPassword"
                                placeholder="Confirm Password"
                                value={registerData.confirmPassword}
                                onChange={handleRegisterChange}
                                required
                            />

                            <input
                                type="checkbox"
                                checked={isSmsConsentChecked}
                                onChange={handleSmsConsentChange}
                            />
                            <label
                            >
                                I agree to receive SMS messages for verification purposes
                            </label>

                            <button type="submit">Sign up</button>
                        </form>
                    </div>

                    {/* Login Form */}
                    <div className="login">
                        <form className="login-form" onSubmit={handleLoginSubmit}>
                            <label htmlFor="chk">
                                Login
                            </label>
                            <input
                               
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={loginData.email}
                                onChange={handleLoginChange}
                                required
                            />
                            <input
                               
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={loginData.password}
                                onChange={handleLoginChange}
                                required
                            />
                            <Link
                                to="/forgotpassword"
                               
                            >
                                forgot password?
                            </Link>
                            <button type="submit">Login</button>
                        </form>
                    </div>
                </div>
            </body>
        </>
    );
};

export default AuthPage;





// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../services/api";
// import "./Styles.css";
// import { Link } from "react-router-dom";
// import payweekwhite from "./ginoc_logo_transparent.png";

// const AuthPage = () => {
//     const [loginData, setLoginData] = useState({ email: "", password: "" });
//     const [registerData, setRegisterData] = useState({
//         first_name: "",
//         last_name: "",
//         email: "",
//         phone: "",
//         password: "",
//         confirmPassword: "",
//     });
//     const [isSmsConsentChecked, setIsSmsConsentChecked] = useState(false);
//     const [isLoginView, setIsLoginView] = useState(false); // Toggle for switching views
//     const navigate = useNavigate();

//     const handleLoginChange = (e) => {
//         const { name, value } = e.target;
//         setLoginData((prevData) => ({ ...prevData, [name]: value }));
//     };

//     const handleLoginSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const { data } = await api.post("/login", loginData);

//             if (data.accessToken) {
//                 api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
//                 alert("Logged in successfully!");
//                 navigate("/dashboard/business/user/profile");
//             } else {
//                 alert(data.message);
//                 navigate("/otp", { state: { userId: data.userId } });
//             }
//         } catch (err) {
//             alert("Login failed.");
//         }
//     };

//     const handleRegisterChange = (e) => {
//         const { name, value } = e.target;
//         setRegisterData((prevData) => ({ ...prevData, [name]: value }));
//     };

//     const handleSmsConsentChange = (e) => {
//         setIsSmsConsentChecked(e.target.checked);
//     };

//     const handleRegisterSubmit = async (e) => {
//         e.preventDefault();
//         if (registerData.password !== registerData.confirmPassword) {
//             alert("Passwords do not match!");
//             return;
//         }
//         if (!isSmsConsentChecked) {
//             alert("You must agree to receive SMS messages for verification purposes.");
//             return;
//         }
//         try {
//             await api.post("/register", registerData);
//             alert("Registration successful!");

//             // Clear the registration form
//             setRegisterData({
//                 first_name: "",
//                 last_name: "",
//                 email: "",
//                 phone: "",
//                 password: "",
//                 confirmPassword: "",
//             });
//             setIsSmsConsentChecked(false);

//             // Switch to the login view
//             setIsLoginView(true);
//             document.getElementById("chk").checked = true; // Toggle the checkbox to switch view
//         } catch (error) {
//             console.error("Registration error:", error.response?.data || error.message);
//             alert(error.response?.data?.message || "Registration failed.");
//         }
//     };

//     return (
//         <>
//             <body className="background">
//                 <div className="logowhite">
//                     <img src={payweekwhite} alt="whitelogo" />
//                 </div>
//                 <div className="main">
//                     <input type="checkbox" id="chk" aria-hidden="true" checked={isLoginView} readOnly />

//                     {/* Register Form */}
//                     <div className="signup">
//                         <form onSubmit={handleRegisterSubmit}>
//                             <label htmlFor="chk" aria-hidden="true">
//                                 Sign up
//                             </label>
//                             <div className="nameinput">
//                                 <input
//                                     style={{ width: "40%", marginLeft: "30px" }}
//                                     type="text"
//                                     name="first_name"
//                                     placeholder="First Name"
//                                     value={registerData.first_name}
//                                     onChange={handleRegisterChange}
//                                     required
//                                 />
//                                 <input
//                                     style={{ width: "40%", marginLeft: "1px" }}
//                                     type="text"
//                                     name="last_name"
//                                     placeholder="Last Name"
//                                     value={registerData.last_name}
//                                     onChange={handleRegisterChange}
//                                     required
//                                 />
//                             </div>
//                             <input
//                                 style={{ marginTop: "-3px" }}
//                                 type="email"
//                                 name="email"
//                                 placeholder="Email"
//                                 value={registerData.email}
//                                 onChange={handleRegisterChange}
//                                 required
//                             />
//                             <input
//                                 type="text"
//                                 name="phone"
//                                 placeholder="Phone"
//                                 value={registerData.phone}
//                                 onChange={handleRegisterChange}
//                                 required
//                             />
//                             <input
//                                 type="password"
//                                 name="password"
//                                 placeholder="Password"
//                                 value={registerData.password}
//                                 onChange={handleRegisterChange}
//                                 required
//                             />
//                             <input
//                                 style={{ marginBottom: "15px" }}
//                                 type="password"
//                                 name="confirmPassword"
//                                 placeholder="Confirm Password"
//                                 value={registerData.confirmPassword}
//                                 onChange={handleRegisterChange}
//                                 required
//                             />

//                             <input
//                                 type="checkbox"
//                                 style={{
//                                     scale: "0.5",
//                                     position: "absolute",
//                                     marginTop: "-8px",
//                                     marginLeft: "-25px",
//                                 }}
//                                 checked={isSmsConsentChecked}
//                                 onChange={handleSmsConsentChange}
//                             />
//                             <label
//                                 style={{
//                                     fontSize: "10px",
//                                     marginLeft: "100px",
//                                     marginTop: "-5.5px",
//                                 }}
//                             >
//                                 I agree to receive SMS messages for verification purposes
//                             </label>

//                             <button type="submit">Sign up</button>
//                         </form>
//                     </div>

//                     {/* Login Form */}
//                     <div className="login">
//                         <form onSubmit={handleLoginSubmit}>
//                             <label htmlFor="chk" aria-hidden="true">
//                                 Login
//                             </label>
//                             <input
//                                 style={{ marginTop: "50px" }}
//                                 type="email"
//                                 name="email"
//                                 placeholder="Email"
//                                 value={loginData.email}
//                                 onChange={handleLoginChange}
//                                 required
//                             />
//                             <input
//                                 style={{ marginBottom: "5px" }}
//                                 type="password"
//                                 name="password"
//                                 placeholder="Password"
//                                 value={loginData.password}
//                                 onChange={handleLoginChange}
//                                 required
//                             />
//                             <Link
//                                 to="/forgotpassword"
//                                 style={{
//                                     marginLeft: "70px",
//                                     marginTop: "-100px",
//                                     cursor: "pointer",
//                                     color: "blue",
//                                 }}
//                             >
//                                 forgot password?
//                             </Link>
//                             <button type="submit">Login</button>
//                         </form>
//                     </div>
//                 </div>
//             </body>
//         </>
//     );
// };

// export default AuthPage;






// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom"; 
// import api from "../services/api"; 
// import "./Styles.css"; 
// import { Link } from "react-router-dom";
// import payweekwhite from "./ginoc_logo_transparent.png";

// const AuthPage = () => {
//     const [loginData, setLoginData] = useState({ email: "", password: "" });
//     const [registerData, setRegisterData] = useState({
//         first_name: "",
//         last_name: "",
//         email: "",
//         phone: "",
//         password: "",
//         confirmPassword: "",
//     });
//     const [isSmsConsentChecked, setIsSmsConsentChecked] = useState(false);
//     const navigate = useNavigate(); 

//     const handleLoginChange = (e) => {
//         const { name, value } = e.target;
//         setLoginData((prevData) => ({ ...prevData, [name]: value }));
//     };

//     const handleLoginSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const { data } = await api.post("/login", loginData);

//             if (data.accessToken) {
//                 api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
//                 alert("Logged in successfully!");
//                 navigate("/dashboard/business/user/profile");
//             } else {
//                 alert(data.message);
//                 navigate("/otp", { state: { userId: data.userId } });
//             }
//         } catch (err) {
//             alert("Login failed.");
//         }
//     };

//     const handleRegisterChange = (e) => {
//         const { name, value } = e.target;
//         setRegisterData((prevData) => ({ ...prevData, [name]: value }));
//     };

//     const handleSmsConsentChange = (e) => {
//         setIsSmsConsentChecked(e.target.checked);
//     };

//     const handleRegisterSubmit = async (e) => {
//         e.preventDefault();
//         if (registerData.password !== registerData.confirmPassword) {
//             alert("Passwords do not match!");
//             return;
//         }
//         if (!isSmsConsentChecked) {
//             alert("You must agree to receive SMS messages for verification purposes.");
//             return;
//         }
//         try {
//             await api.post("/register", registerData);
//             alert("Registration successful!");
//             navigate("/authpage");
//         } catch (error) {
//             console.error("Registration error:", error.response?.data || error.message);
//             alert(error.response?.data?.message || "Registration failed.");
//         }
//     };

//     return (
//         <>
//         <body className="background">
//         <div className="logowhite">
//             <img src={payweekwhite} alt="whitelogo" />
//         </div>
//         <div className="main">
//             <input type="checkbox" id="chk" aria-hidden="true" />

//             {/* Register Form */}
//             <div className="signup">
//                 <form onSubmit={handleRegisterSubmit}>
//                     <label htmlFor="chk" aria-hidden="true">
//                         Sign up
//                     </label>
//                     <div className="nameinput">
//                         <input
//                             style={{ width: '40%', marginLeft: '30px' }}
//                             type="text"
//                             name="first_name"
//                             placeholder="First Name"
//                             value={registerData.first_name}
//                             onChange={handleRegisterChange}
//                             required
//                         />
//                         <input
//                             style={{ width: '40%', marginLeft: '1px' }}
//                             type="text"
//                             name="last_name"
//                             placeholder="Last Name"
//                             value={registerData.last_name}
//                             onChange={handleRegisterChange}
//                             required
//                         />
//                     </div>
//                     <input
//                         style={{ marginTop: '-3px' }}
//                         type="email"
//                         name="email"
//                         placeholder="Email"
//                         value={registerData.email}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     <input
//                         type="text"
//                         name="phone"
//                         placeholder="Phone"
//                         value={registerData.phone}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     <input
//                         type="password"
//                         name="password"
//                         placeholder="Password"
//                         value={registerData.password}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     <input
//                         style={{ marginBottom: "15px" }}
//                         type="password"
//                         name="confirmPassword"
//                         placeholder="Confirm Password"
//                         value={registerData.confirmPassword}
//                         onChange={handleRegisterChange}
//                         required
//                     />

//                     <input 
//                         type="checkbox" 
//                         style={{ scale: '0.5', position: 'absolute', marginTop: '-8px', marginLeft: '-25px' }} 
//                         checked={isSmsConsentChecked}
//                         onChange={handleSmsConsentChange}
//                     />
//                     <label style={{ fontSize: '10px', marginLeft: '100px', marginTop: '-5.5px' }}>
//                         I agree to receive SMS messages for verification purposes
//                     </label>

//                     <button type="submit">Sign up</button>
//                 </form>
//             </div>

//             {/* Login Form */}
//             <div className="login">
//                 <form onSubmit={handleLoginSubmit}>
//                     <label htmlFor="chk" aria-hidden="true">
//                         Login
//                     </label>
//                     <input
//                         style={{ marginTop: "50px" }}
//                         type="email"
//                         name="email"
//                         placeholder="Email"
//                         value={loginData.email}
//                         onChange={handleLoginChange}
//                         required
//                     />
//                     <input
//                         style={{ marginBottom: "5px" }}
//                         type="password"
//                         name="password"
//                         placeholder="Password"
//                         value={loginData.password}
//                         onChange={handleLoginChange}
//                         required
//                     />
//                     <Link
//                         to="/forgotpassword"
//                         style={{ marginLeft: "70px", marginTop: "-100px", cursor: "pointer", color: "blue" }}
//                     >
//                         forgot password?
//                     </Link>
//                     <button type="submit">Login</button>
//                 </form>
//             </div>
//         </div>
//         </body>
//         </>
//     );
// };

// export default AuthPage;



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom"; // Navigation
// import api from "../services/api"; // Axios instance
// import "./Styles.css"; // Import the CSS for styling
// import { Link } from "react-router-dom";
// import payweekwhite from "./ginoc_logo_transparent.png";

// const AuthPage = () => {
//     const [loginData, setLoginData] = useState({ email: "", password: "" });
//     const [registerData, setRegisterData] = useState({
//         first_name: "",
//         last_name: "",
//         email: "",
//         phone: "",
//         password: "",
//         confirmPassword: "",
//     });
//     const navigate = useNavigate(); // React Router hook for navigation

//     // Handlers for Login Form
//     const handleLoginChange = (e) => {
//         const { name, value } = e.target;
//         setLoginData((prevData) => ({ ...prevData, [name]: value }));
//     };

//     const handleLoginSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const {data} = await api.post("/login", loginData);

//             if (data.accessToken) {
//                 api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
//                 alert("Logged in successfully!");
//                 navigate("/dashboard/business/user/profile");
//             } else {
//                 alert(data.message);
//                 navigate("/otp", { state: { userId: data.userId } });
//             }

            
//         } catch (err) {
//             alert("Login failed.");
//         }
//     };


//     // Handlers for Register Form
//     const handleRegisterChange = (e) => {
//         const { name, value } = e.target;
//         setRegisterData((prevData) => ({ ...prevData, [name]: value }));
//     };

//     const handleRegisterSubmit = async (e) => {
//         e.preventDefault();
//         if (registerData.password !== registerData.confirmPassword) {
//             alert("Passwords do not match!");
//             return;
//         }
//         try {
//             await api.post("/register", registerData);
//             alert("Registration successful!");
//             navigate("/authpage");
//         } catch (error) {
//             console.error("Registration error:", error.response?.data || error.message);
//             alert(error.response?.data?.message || "Registration failed.");
//         }
//     };

//     return (
//         <>
//         <body className="background">
//         <div className="logowhite">
//             <img src={payweekwhite} alt="whitelogo"/>
//         </div>
//         <div className="main">
//             <input type="checkbox" id="chk" aria-hidden="true" />

//             {/* Register Form */}
//             <div className="signup">
//                 <form onSubmit={handleRegisterSubmit}>
//                     <label htmlFor="chk" aria-hidden="true">
//                         Sign up
//                     </label>
//                     <div className="nameinput">
//                     <input
//                         style={{width:'40%', marginLeft:'30px'}}
//                         type="text"
//                         name="first_name"
//                         placeholder="First Name"
//                         value={registerData.first_name}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     <input
//                         style={{width:'40%', marginLeft:'1px'}}
//                         type="text"
//                         name="last_name"
//                         placeholder="Last Name"
//                         value={registerData.last_name}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     </div>
//                     <input
//                         style={{marginTop:'-3px'}}
//                         type="email"
//                         name="email"
//                         placeholder="Email"
//                         value={registerData.email}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     <input
//                         type="text"
//                         name="phone"
//                         placeholder="Phone"
//                         value={registerData.phone}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     <input
//                         type="password"
//                         name="password"
//                         placeholder="Password"
//                         value={registerData.password}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     <input style={{marginBottom:"15px"}}
//                         type="password"
//                         name="confirmPassword"
//                         placeholder="Confirm Password"
//                         value={registerData.confirmPassword}
//                         onChange={handleRegisterChange}
//                         required
//                     />
//                     <input type="checkbox" style={{scale:'0.5', position:'absolute', marginTop:'-8px', marginLeft:'-25px' }} /><label style={{fontSize:'10px', marginLeft:'100px', marginTop:'-5.5px'}}>I agree to receive SMS messages for verification purposes</label>
//                     <button type="submit">Sign up</button>
//                 </form>
//             </div>

//             {/* Login Form */}
//             <div className="login">
//                 <form onSubmit={handleLoginSubmit}>
//                     <label htmlFor="chk" aria-hidden="true">
//                         Login
//                     </label>
//                     <input style={{marginTop:"50px"}}
//                         type="email"
//                         name="email"
//                         placeholder="Email"
//                         value={loginData.email}
//                         onChange={handleLoginChange}
//                         required
//                     />
//                     <input style={{marginBottom:"5px"}}
//                         type="password"
//                         name="password"
//                         placeholder="Password"
//                         value={loginData.password}
//                         onChange={handleLoginChange}
//                         required
//                     />
//                     <Link to="/forgotpassword" style={{marginLeft:"70px", marginTop:"-100px", cursor: "pointer", color: "blue"}}>forgot password?</Link>
//                     <button type="submit">Login</button>
//                 </form>
//             </div>
//         </div>
//         </body>
//         </>
//     );
// };


// export default AuthPage;
